// @greenlight-spec: 28-it-dashboard-ui.md
import { Alert, AlertDescription } from '@/components/ui/alert';

export function RefreshWarning() {
  return (
    <Alert>
      <AlertDescription>
        Couldn't refresh. Showing the last update; retrying automatically.
      </AlertDescription>
    </Alert>
  );
}
